import { render } from "./CollectionView.vue?vue&type=template&id=1cd20f60&ts=true"
import script from "./CollectionView.vue?vue&type=script&lang=ts"
export * from "./CollectionView.vue?vue&type=script&lang=ts"

import "./CollectionView.vue?vue&type=style&index=0&id=1cd20f60&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__